import { Component } from '@angular/core';
import { B2wAttributeComponent } from './b2w-attribute.component';



@Component({
    selector: 'app-b2w-attribute',
    templateUrl: './b2w-attribute.component.html',
    styleUrl: './b2w-attribute.component.scss',
    standalone: false
})
export class B2wAttributeVarComponent extends B2wAttributeComponent   {

  
  variacao = true;
  table = 'Mktpskyhubspecificationsvar';
  

}
